import { atom } from 'jotai';
import type { footerAnimateConfig } from '@/libs/global-config';

/**
 * null 表示配置尚未加载或加载失败（不展示动画）
 * 非 null 时按配置判断是否展示动画
 */
export const footerAnimateConfigAtom = atom<footerAnimateConfig | null>(null);
